import { post, get } from './index';
import { apiMap } from '@qm-activity/common/assets/ts/const';
// 初始化微信配置
export const apiInitWxConfig = (url: string) => {
    return post(`${apiMap.apiMa}/marathon/api/v1/get-share-info`, { url, });
};

// 我的奖品页
export const apiMyPrize = () => {
    return get(`${apiMap.apiMa}/marathon/api/v1/my-prize`);
};

// 兑换邀请口令
export const apiExchangeInviteCode = (invite_code: string) => {
    return post(`${apiMap.apiMa}/marathon/api/v1/friend-support/exchange-invite-code-pass`, { invite_code, });
};

// 分享动作上报
export const apiShareActionReport = (invite_code: string) => {
    if (!invite_code) {
        return;
    }
    return post(`${apiMap.apiMa}/marathon/api/v1/friend-support/share-log`, { invite_code, });
};
